import ReactGoogleAutocomplete, {
  ReactGoogleAutocompleteInputProps,
} from 'react-google-autocomplete';
import {TypeGooglePlaceDetail} from './types';
import styles from './GooglePlaceAutoComplete.module.scss';
import {extractAddressFromPlaceDetails} from './lib/google-place-helpers';
import FieldWrapper from 'components/FieldWrapper/FieldWrapper';

interface IGooglePlaceAutoComplete {
  onPlaceSelected: (value: TypeGooglePlaceDetail) => void;
  label?: string;
  error?: string;
  disabled?: boolean;
  placeholder?: string;
  wrapperClass?: string;
  apiKey?: string;
}
export const GooglePlaceAutoComplete = (
  props: IGooglePlaceAutoComplete &
    Omit<ReactGoogleAutocompleteInputProps, 'onPlaceSelected'>
) => {
  const {apiKey, wrapperClass, label, error, onPlaceSelected, ...rest} = props;
  const GOOGLE_API_KEY = props.apiKey || process.env.REACT_APP_GOOGLE_API_KEY;

  const handlePlaceSelected = (place: any) => {
    const detailedAddresses = extractAddressFromPlaceDetails(place);
    onPlaceSelected(detailedAddresses);
  };

  return (
    <FieldWrapper className={wrapperClass} label={label} error={error}>
      <ReactGoogleAutocomplete
        {...rest}
        options={{
          types: ['address'],
          componentRestrictions: {country: 'us'},
        }}
        apiKey={GOOGLE_API_KEY}
        libraries={['places']}
        onPlaceSelected={handlePlaceSelected}
        className={styles.google_place_auto_complete}
        language="en"
      />
    </FieldWrapper>
  );
};
